import icon from 'vue-svgicon';

icon.register({
    'bold/check-2': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M22.455 0H1.545A1.547 1.547 0 0 0 0 1.545v20.909A1.547 1.547 0 0 0 1.545 24h20.91A1.547 1.547 0 0 0 24 22.454V1.545A1.547 1.547 0 0 0 22.455 0zm-3.65 7.844l-7 9.5a1.013 1.013 0 0 1-1.43.187l-5-4a1 1 0 1 1 1.25-1.561l4.187 3.35L17.2 6.656a1 1 0 1 1 1.61 1.187z"/>`,
    },
});
